<template>
  <van-popup v-model="show">
    <img :src="qrCode" alt="" class="auth-qrcode" />
    <div class="auth-tips">请用支付宝扫一扫</div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';
import QRCode from 'qrcode';

export default {
  data() {
    return {
      show: true,
      url: '',
      qrCode: '',
    };
  },
  created() {
    this.canvasToBlobPolyfill();
    this.getQRCode();
  },
  methods: {
    canvasToBlobPolyfill() {
      if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
          value: function (callback, type, quality) {
            var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
              len = binStr.length,
              arr = new Uint8Array(len);

            for (var i = 0; i < len; i++) {
              arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], { type: type || 'image/png' }));
          },
        });
      }
    },
    getQRCode() {
      return new Promise((resolve, reject) => {
        QRCode.toCanvas(this.url, {
          margin: 0,
        })
          .then((canvas) => {
            canvas.toBlob((blob) => {
              const blobURL = URL.createObjectURL(blob);
              this.qrCode = blobURL;
              resolve(blobURL);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  components: {
    [Popup.name]: Popup,
  },
};
</script>

<style lang="scss" scoped>
.auth-qrcode {
  width: 250px;
  height: 250px;
  border: 10px solid #ffffff;
  border-radius: 8px;
}
.auth-tips {
  text-align: center;
  margin-top: 14px;
  color: #ffffff;
}
</style>
